import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { BadgeComponent } from '@pool-league/frontend-shared-ui-common';
import { RouterLink } from '@angular/router';

export type CompetitionStatus = 'Draft' | 'Active' | 'Complete';

@Component({
  selector: 'lib-web-competition-badges',
  imports: [BadgeComponent, RouterLink],
  templateUrl: './competition-badges.component.html',
  styleUrl: './competition-badges.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompetitionBadgesComponent {
  /**
   * The next status, if allowed to change to it.
   */
  readonly nextStatus = input<CompetitionStatus | undefined>(undefined);
  readonly status = input<CompetitionStatus | undefined>();
  readonly canEdit = input<boolean>(false);

  readonly mood = computed(() => {
    const status = this.status();
    return !status
      ? 'negative'
      : status === 'Active' // TODO: Use a shared const instead of the literal 'Active'?
        ? 'positive'
        : 'neutral';
  });
}
